<template>
  <div class="mt-4">
    <header class="mx-auto container">
      <h1 class="text-lg font-bold">Transfer Balance Cap Calculator</h1>
    </header>
    <main class="mt-4 mx-auto container">
      <div class="rounded bg-white overflow-hidden">
        <transfer-balance-cap-container />
      </div>
    </main>
  </div>
</template>

<script>
import TransferBalanceCapContainer from '../../../modules/transfer-balance-cap/containers/transfer-balance-cap-container/transfer-balance-cap-container.vue';

export default {
  name: 'wizard-tbc-view',
  components: {
    TransferBalanceCapContainer,
  },
};
</script>

<style>

</style>
